import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  RevenueBreakdownParams,
  RevenueBreakdownResponse
} from "../financialReport.types";
import { requestRevenueBreakdown } from "./revenueBreakdown.request";

const useRevenueBreakdown = (
  params: RevenueBreakdownParams,
  options?: QueryOptions<RevenueBreakdownResponse, ApiServiceError<ApiError>>
) => {
  return useQuery({
    queryKey: ["revenue-breakdown", params],
    queryFn: async () => await requestRevenueBreakdown(params),
    onError: toastServerError,
    ...options
  });
};

export default useRevenueBreakdown;
